import { ReportTranslationKeys } from 'intl/keys';
import { ImageDisplayStyle } from 'shared/domain/report/types/model/common';

export const REPORT_FILE_INFO_CHIP_TOOLTIP_LABELS = {
  names: ReportTranslationKeys.fileInfoChipNamesTooltip,
  descriptions: ReportTranslationKeys.fileInfoChipDescriptionsTooltip,
  activeLinks: ReportTranslationKeys.fileInfoChipActiveLinksTooltip,
  phoneNumbers: ReportTranslationKeys.fileInfoChipPhoneNumbersTooltip,
  userEmails: ReportTranslationKeys.fileInfoChipUserEmailsTooltip,
} as const;

/** UI order: list → miniatures → large images. */
export const IMAGE_DISPLAY_STYLE_UI_ORDER: ImageDisplayStyle[] = [
  ImageDisplayStyle.list,
  ImageDisplayStyle.miniatures,
  ImageDisplayStyle.fullPage,
];
